/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} tableReservationsPageFirstComponentClicksParams
* @property {string} buttonType - up_right / when_no_reservations_yet
* @property {GUID} locationGuid - -
* @property {GUID} biToken - -
* @property {number} numReservations - number of reservations in the page
* @property {string} rest_id - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservations page > first component clicks. Evid: 1406.
 * Event description: table reservations page - when the user click on one of these - settings / create reservation.

 * buttonType - Type: string. Desc: up_right / when_no_reservations_yet
 *
 * locationGuid - Type: guid. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * numReservations - Type: numeric. Desc: number of reservations in the page
 *
 * rest_id - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationsPageFirstComponentClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsPageFirstComponentClicks = function (params) {
    return { evid: 1406, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilityPageChangesSavesSuccessfullyParams
* @property {string} advancedNoticeType - minuted / hours/ days
* @property {string} availabilityHoursList - son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
* @property {string} advancedNoticeNum - -
* @property {string} defaultTime - of reservation duration
* @property {string} displayPhoneCheckbox - check/ uncheck
* @property {string} durationRulesList - json list of the rules
* @property {number} guestsMinutes - right now should be 15
* @property {number} guestsPacing - -
* @property {GUID} locationGuid - -
* @property {number} maxPartySize - -
* @property {number} minPartySize - -
* @property {number} numExistingEvents - number of events that were existing before this saving
* @property {number} numNewEvents - number of new events at the availability modal
* @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
* @property {string} pageName - availability_settings
* @property {number} partiesMinutes - right now should be 15
* @property {number} partiesPacing - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} scheduleType - null
**/
/**
 * Name: Table reservation > settings > availability page > changes saves successfully. Evid: 1452.
 * Event description: changes saves successfully.

 * advancedNoticeType - Type: string. Desc: minuted / hours/ days
 *
 * availabilityHoursList - Type: string. Desc: son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 *
 * advancedNoticeNum - Type: string. Desc: -
 *
 * defaultTime - Type: string. Desc: of reservation duration
 *
 * displayPhoneCheckbox - Type: string. Desc: check/ uncheck
 *
 * durationRulesList - Type: string. Desc: json list of the rules
 *
 * guestsMinutes - Type: numeric. Desc: right now should be 15
 *
 * guestsPacing - Type: numeric. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxPartySize - Type: numeric. Desc: -
 *
 * minPartySize - Type: numeric. Desc: -
 *
 * numExistingEvents - Type: numeric. Desc: number of events that were existing before this saving
 *
 * numNewEvents - Type: numeric. Desc: number of new events at the availability modal
 *
 * numTurnoverRules - Type: numeric. Desc: how many rules of turnover are exist at the loading
 *
 * pageName - Type: string. Desc: availability_settings
 *
 * partiesMinutes - Type: numeric. Desc: right now should be 15
 *
 * partiesPacing - Type: numeric. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * scheduleType - Type: string.
 * @param {tableReservationSettingsAvailabilityPageChangesSavesSuccessfullyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityPageChangesSavesSuccessfully = function (params) {
    return { evid: 1452, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSetLocationsModalTooltipClicksParams
* @property {string} buttonName - X / set_up_location/external if its click outside the modal
* @property {string} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > set locations modal tooltip clicks. Evid: 1437.
 * Event description: click inside the modal of " table reservation are automatically assigned to your restaurant location- set up location".

 * buttonName - Type: string. Desc: X / set_up_location/external if its click outside the modal
 *
 * instanceId - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSetLocationsModalTooltipClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSetLocationsModalTooltipClicks = function (params) {
    return { evid: 1437, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilitySettingsPartySizeComponentDurationRulesModalClickOnApplyParams
* @property {string} defaultDuration - -
* @property {boolean} defaultDurationChanged - true if it changes and false otherwise
* @property {GUID} locationGuid - -
* @property {number} numRules - -
* @property {boolean} numRulesChanged - true if it changes and false otherwise
* @property {string} restId - -
* @property {string} rulesList - (json as “min:x, max:x, duratoins:x”)
**/
/**
 * Name: Table reservation > settings > availability settings > party size component > duration rules modal > click on apply. Evid: 1431.
 * Event description: click on apply inside duration rules modal.

 * defaultDuration - Type: string. Desc: -
 *
 * defaultDurationChanged - Type: bool. Desc: true if it changes and false otherwise
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numRules - Type: numeric. Desc: -
 *
 * numRulesChanged - Type: bool. Desc: true if it changes and false otherwise
 *
 * restId - Type: string. Desc: -
 *
 * rulesList - Type: string. Desc: (json as “min:x, max:x, duratoins:x”)
 * @param {tableReservationSettingsAvailabilitySettingsPartySizeComponentDurationRulesModalClickOnApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilitySettingsPartySizeComponentDurationRulesModalClickOnApply = function (params) {
    return { evid: 1431, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} copyOfTableReservationSetLocationsTooltipIsJumpingParams
* @property {string} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > set locations tooltip is jumping. Evid: 1438.
 * Event description: when the modal of " table reservation are automatically assigned to your restaurant location- set up location" is jumping.

 * instanceId - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {copyOfTableReservationSetLocationsTooltipIsJumpingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyOfTableReservationSetLocationsTooltipIsJumping = function (params) {
    return { evid: 1438, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} webReservationsUserScreenOpenParams
* @property {string} origin - widget / page
* @property {string} screenName - unique screen name
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.User.ScreenOpen. Evid: 1402.
 * Event description: Screen Open events in User Web flows (BM/Preview/Site)..

 * origin - Type: string. Desc: widget / page
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUserScreenOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUserScreenOpen = function (params) {
    return { evid: 1402, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsClickOnReservationsAttributesParams
* @property {string} correlationId - -
* @property {string} fieldName - Date/Time/Party Size/Location
* @property {GUID} instance_id - instance_id
* @property {boolean} isAddOn - true/ false
* @property {boolean} isMultiLocation - true if the site has more than one location
* @property {GUID} locationGuid - location ID
* @property {GUID} bi_token - msid
* @property {string} organization_id - organization_id
* @property {string} origin - live_site_mode / preview_mode
* @property {GUID} reservationLocationId - -
* @property {GUID} visitorId - visitor_id
**/
/**
 * Name: Table Reservations -> click on reservations attributes. Evid: 1455.
 * Event description: uou clicked on any of the reservation settings.

 * correlationId - Type: string. Desc: -
 *
 * fieldName - Type: string. Desc: Date/Time/Party Size/Location
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * isAddOn - Type: bool. Desc: true/ false
 *
 * isMultiLocation - Type: bool. Desc: true if the site has more than one location
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * bi_token - Type: guid. Desc: msid
 *
 * organization_id - Type: string. Desc: organization_id
 *
 * origin - Type: string. Desc: live_site_mode / preview_mode
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * visitorId - Type: guid. Desc: visitor_id
 * @param {tableReservationsClickOnReservationsAttributesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsClickOnReservationsAttributes = function (params) {
    return { evid: 1455, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsReservationsPageUpperComponentClicksParams
* @property {string} columnsOrder - json of the columns name by their order
* @property {DateTime} currentDate - the date of the reservations on the page
* @property {string} element - eight_arrow / left_arrow / date_title / date / customize_columns
* @property {boolean} isEmpty - id the page is empty of reservations
* @property {GUID} locationGuid - -
* @property {DateTime} moveToDate - the date the user click on
* @property {string} biToken - -
* @property {number} numColumns - -
* @property {number} numReservations - num of reservations in the page
* @property {string} uuid - -
**/
/**
 * Name: Table reservations > reservations page > upper component clicks. Evid: 1413.
 * Event description: when the user clicks on some elements on the reservations page in the upper component of the page..

 * columnsOrder - Type: string. Desc: json of the columns name by their order
 *
 * currentDate - Type: datetime. Desc: the date of the reservations on the page
 *
 * element - Type: string. Desc: eight_arrow / left_arrow / date_title / date / customize_columns
 *
 * isEmpty - Type: bool. Desc: id the page is empty of reservations
 *
 * locationGuid - Type: guid. Desc: -
 *
 * moveToDate - Type: datetime. Desc: the date the user click on
 *
 * biToken - Type: string. Desc: -
 *
 * numColumns - Type: numeric. Desc: -
 *
 * numReservations - Type: numeric. Desc: num of reservations in the page
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationsReservationsPageUpperComponentClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsReservationsPageUpperComponentClicks = function (params) {
    return { evid: 1413, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsClickOnNavigationButtonsParams
* @property {string} clickName - -
* @property {string} currentPageName - -
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > click on navigation buttons. Evid: 1426.
 * Event description: when user clicks on the navigation buttons on the top of tha settings pages (settings / reservation settings / tablemanagement / availability / notifictions / reservation form).

 * clickName - Type: string. Desc: -
 *
 * currentPageName - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsClickOnNavigationButtonsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsClickOnNavigationButtons = function (params) {
    return { evid: 1426, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationCreateReservationModalClicksParams
* @property {string} clickName - last_name/email/phone/date/party_size/duration/assign_table/additional_details
* @property {string} locationGuid - -
* @property {string} modalType - edit/ create
* @property {string} biToken - -
* @property {number} numAdditionalFileds - -
* @property {number} numMandatoryFileds - -
* @property {string} rest_id - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > create reservation modal > clicks. Evid: 1412.
 * Event description: clicks on the sections that the user should fill like first name. last name and more....

 * clickName - Type: string. Desc: last_name/email/phone/date/party_size/duration/assign_table/additional_details
 *
 * locationGuid - Type: string. Desc: -
 *
 * modalType - Type: string. Desc: edit/ create
 *
 * biToken - Type: string. Desc: -
 *
 * numAdditionalFileds - Type: numeric. Desc: -
 *
 * numMandatoryFileds - Type: numeric. Desc: -
 *
 * rest_id - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationCreateReservationModalClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationCreateReservationModalClicks = function (params) {
    return { evid: 1412, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsReservationsFormPageGeneralClicksParams
* @property {string} actionType - click/check/uncheck / start_typing/hover
* @property {string} buttonName - delete/mandatory_field/add_custom_field/message/check_by_default...
* @property {GUID} locationGuid - -
* @property {string} restId - -
* @property {string} section - last_name_as_mandatory / email_margeting_checkbox / custom_fields...
**/
/**
 * Name: Table reservation > settings > reservations form page > general clicks. Evid: 1436.
 * Event description: when the user clicks on one of the toggles on the reservation form page.

 * actionType - Type: string. Desc: click/check/uncheck / start_typing/hover
 *
 * buttonName - Type: string. Desc: delete/mandatory_field/add_custom_field/message/check_by_default...
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * section - Type: string. Desc: last_name_as_mandatory / email_margeting_checkbox / custom_fields...
 * @param {tableReservationSettingsReservationsFormPageGeneralClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsReservationsFormPageGeneralClicks = function (params) {
    return { evid: 1436, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilitySettingsPartySizeComponentDurationRulesModalClicksParams
* @property {string} availabilityComponent - online_reservations / party_size / advances_notice / pacing/ duration_modal
* @property {string} buttonName - deafult_duration / min / max / min_arrows / max_arrows / duration/add_rule/cancel
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > availability settings > party size component > duration rules modal > clicks. Evid: 1430.
 * Event description: click on buttons inside duration rules modal.

 * availabilityComponent - Type: string. Desc: online_reservations / party_size / advances_notice / pacing/ duration_modal
 *
 * buttonName - Type: string. Desc: deafult_duration / min / max / min_arrows / max_arrows / duration/add_rule/cancel
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsAvailabilitySettingsPartySizeComponentDurationRulesModalClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilitySettingsPartySizeComponentDurationRulesModalClicks = function (params) {
    return { evid: 1430, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} restaurantsTableReservationsSettingsTableManagementTabsLoadedParams
* @property {GUID} locationGuid - -
* @property {number} numObjects - num of tables in tables tab or num of tables combinations in table combinations tab
* @property {number} numOfOnlineObjects - only online tables and combinations
* @property {GUID} reservationLocationId - -
* @property {string} tabName - tables/ tables_comnbinations
* @property {number} totalSeats - -
**/
/**
 * Name: Restaurants > Table Reservations > Settings > Table management > Tabs loaded. Evid: 1457.
 * Event description: when tables tab or tables combinations tab are loaded.

 * locationGuid - Type: guid. Desc: -
 *
 * numObjects - Type: numeric. Desc: num of tables in tables tab or num of tables combinations in table combinations tab
 *
 * numOfOnlineObjects - Type: numeric. Desc: only online tables and combinations
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * tabName - Type: string. Desc: tables/ tables_comnbinations
 *
 * totalSeats - Type: numeric. Desc: -
 * @param {restaurantsTableReservationsSettingsTableManagementTabsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsTableReservationsSettingsTableManagementTabsLoaded = function (params) {
    return { evid: 1457, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsSettingsReservationFormSavePageSucceedParams
* @property {string} customFieldsText - json with the text and +mandatory if it is
* @property {string} customFieldsToggle - on/off
* @property {string} customMessageText - json
* @property {string} customMessageToggle - on/off
* @property {string} emailMandatoryToggle - on/off
* @property {string} emailMarketingCheckByDeafult - check/uncheck
* @property {string} emailMarketingCheckboxToggle - on/off
* @property {string} lastNameMandatoryToggle - on/off
* @property {GUID} locationGuid - -
* @property {number} numCustomFields - -
* @property {number} numMandatoryFileds - -
* @property {string} phoneValidationToggle - on/off
* @property {string} policiesTermsCond - check/uncheck
* @property {string} privacyPolicy - check/uncheck
* @property {string} privacyPolicyText - json of the text
* @property {string} privacyPolicyType - text/url/null
* @property {GUID} reservationLocationId - -
* @property {string} reservationPoliciesToggle - on/off
* @property {string} restId - -
* @property {string} termsAndConditionsText - json of the text
* @property {string} termsCondType - text/url/null
**/
/**
 * Name: Table reservations > settings > reservation form  > save page succeed. Evid: 1453.
 * Event description: click on save reservation form page.

 * customFieldsText - Type: string. Desc: json with the text and +mandatory if it is
 *
 * customFieldsToggle - Type: string. Desc: on/off
 *
 * customMessageText - Type: string. Desc: json
 *
 * customMessageToggle - Type: string. Desc: on/off
 *
 * emailMandatoryToggle - Type: string. Desc: on/off
 *
 * emailMarketingCheckByDeafult - Type: string. Desc: check/uncheck
 *
 * emailMarketingCheckboxToggle - Type: string. Desc: on/off
 *
 * lastNameMandatoryToggle - Type: string. Desc: on/off
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numCustomFields - Type: numeric. Desc: -
 *
 * numMandatoryFileds - Type: numeric. Desc: -
 *
 * phoneValidationToggle - Type: string. Desc: on/off
 *
 * policiesTermsCond - Type: string. Desc: check/uncheck
 *
 * privacyPolicy - Type: string. Desc: check/uncheck
 *
 * privacyPolicyText - Type: string. Desc: json of the text
 *
 * privacyPolicyType - Type: string. Desc: text/url/null
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationPoliciesToggle - Type: string. Desc: on/off
 *
 * restId - Type: string. Desc: -
 *
 * termsAndConditionsText - Type: string. Desc: json of the text
 *
 * termsCondType - Type: string. Desc: text/url/null
 * @param {tableReservationsSettingsReservationFormSavePageSucceedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsSettingsReservationFormSavePageSucceed = function (params) {
    return { evid: 1453, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsSpecificSectionDiscardChangesModalClicksParams
* @property {string} buttonName - x / cance / discars changes
* @property {string} currentToggle - toggle_off/ toggle_on
* @property {string} locationGuid - -
* @property {string} restId - -
* @property {string} settingsSection - table_manage/ availability/ reservation_form/ notifications
**/
/**
 * Name: Table reservation > settings > specific section > discard changes > modal clicks. Evid: 1421.
 * Event description: clicks inside discard changes modal in each of the 4 settings sections.

 * buttonName - Type: string. Desc: x / cance / discars changes
 *
 * currentToggle - Type: string. Desc: toggle_off/ toggle_on
 *
 * locationGuid - Type: string. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * settingsSection - Type: string. Desc: table_manage/ availability/ reservation_form/ notifications
 * @param {tableReservationSettingsSpecificSectionDiscardChangesModalClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsSpecificSectionDiscardChangesModalClicks = function (params) {
    return { evid: 1421, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalClickOnScheduleTypeParams
* @property {string} element - -
* @property {number} eventId - -
* @property {GUID} locationId - -
* @property {string} restId - -
* @property {string} type - opening_hours/custom_hours
**/
/**
 * Name: Table reservation > settings > Availability > Online reservation section > schedule modal >clicks. Evid: 1444.
 * Event description: clicks inside schedule modal.

 * element - Type: string. Desc: -
 *
 * eventId - Type: numeric. Desc: -
 *
 * locationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * type - Type: string. Desc: opening_hours/custom_hours
 * @param {tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalClickOnScheduleTypeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalClickOnScheduleType = function (params) {
    return { evid: 1444, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsSettingsReservationFormClickOnSaveParams
* @property {string} customFieldsText - json with the text and +mandatory if it is
* @property {string} customFieldsToggle - on/off
* @property {string} customMessageText - json
* @property {string} customMessageToggle - on/off
* @property {string} emailMandatoryToggle - on/off
* @property {string} emailMarketingCheckByDeafult - check/uncheck
* @property {string} emailMarketingCheckboxToggle - on/off
* @property {string} lastNameMandatoryToggle - on/off
* @property {GUID} locationGuid - -
* @property {number} numCustomFields - -
* @property {number} numMandatoryFileds - -
* @property {string} phoneValidationToggle - on/off
* @property {string} policiesTermsCond - check/uncheck
* @property {string} privacyPolicy - check/uncheck
* @property {string} privacyPolicyText - json of the text
* @property {string} privacyPolicyType - text/url/null
* @property {string} reservationPoliciesToggle - on/off
* @property {string} restId - -
* @property {string} termsAndConditionsText - json of the text
* @property {string} termsCondType - text/url/null
**/
/**
 * Name: Table reservations > settings > reservation form  > click on save. Evid: 1434.
 * Event description: click on save reservation form page.

 * customFieldsText - Type: string. Desc: json with the text and +mandatory if it is
 *
 * customFieldsToggle - Type: string. Desc: on/off
 *
 * customMessageText - Type: string. Desc: json
 *
 * customMessageToggle - Type: string. Desc: on/off
 *
 * emailMandatoryToggle - Type: string. Desc: on/off
 *
 * emailMarketingCheckByDeafult - Type: string. Desc: check/uncheck
 *
 * emailMarketingCheckboxToggle - Type: string. Desc: on/off
 *
 * lastNameMandatoryToggle - Type: string. Desc: on/off
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numCustomFields - Type: numeric. Desc: -
 *
 * numMandatoryFileds - Type: numeric. Desc: -
 *
 * phoneValidationToggle - Type: string. Desc: on/off
 *
 * policiesTermsCond - Type: string. Desc: check/uncheck
 *
 * privacyPolicy - Type: string. Desc: check/uncheck
 *
 * privacyPolicyText - Type: string. Desc: json of the text
 *
 * privacyPolicyType - Type: string. Desc: text/url/null
 *
 * reservationPoliciesToggle - Type: string. Desc: on/off
 *
 * restId - Type: string. Desc: -
 *
 * termsAndConditionsText - Type: string. Desc: json of the text
 *
 * termsCondType - Type: string. Desc: text/url/null
 * @param {tableReservationsSettingsReservationFormClickOnSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsSettingsReservationFormClickOnSave = function (params) {
    return { evid: 1434, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalDeleteCustomRuleParams
* @property {boolean} checkbox - true (check) /false (uncheck)
* @property {DateTime} fromTime - -
* @property {GUID} locationId - -
* @property {number} numDays - -
* @property {string} restId - -
* @property {DateTime} toTime - -
**/
/**
 * Name: Table reservation > settings > Availability > Online reservation section > schedule modal > delete custom rule. Evid: 1445.
 * Event description: clicks inside schedule modal on delete custom rule.

 * checkbox - Type: bool. Desc: true (check) /false (uncheck)
 *
 * fromTime - Type: datetime. Desc: -
 *
 * locationId - Type: guid. Desc: -
 *
 * numDays - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * toTime - Type: datetime. Desc: -
 * @param {tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalDeleteCustomRuleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalDeleteCustomRule = function (params) {
    return { evid: 1445, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsPageToggleAction1448Params
* @property {string} action_type - toggle_off/ toggle_on
* @property {string} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings page > toggle action. Evid: 1448.
 * Event description: when the user clicks on the toggle.

 * action_type - Type: string. Desc: toggle_off/ toggle_on
 *
 * locationGuid - Type: string. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsPageToggleAction1448Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsPageToggleAction1448 = function (params) {
    return { evid: 1448, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} restaurantsTableReservationsSettingsTableManagementAvailableOnlineHoverParams
* @property {GUID} locationGuid - -
* @property {number} numObjects - -
* @property {number} numOfOnlineObjects - -
* @property {GUID} reservationLocationId - -
* @property {GUID} reservationsLocationId - -
* @property {string} tabName - -
* @property {number} totalSeats - -
**/
/**
 * Name: Restaurants > Table Reservations > Settings > Table management > available online hover. Evid: 1458.
 * Event description: hover on "available online".

 * locationGuid - Type: guid. Desc: -
 *
 * numObjects - Type: numeric. Desc: -
 *
 * numOfOnlineObjects - Type: numeric. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationsLocationId - Type: guid. Desc: -
 *
 * tabName - Type: string. Desc: -
 *
 * totalSeats - Type: numeric. Desc: -
 * @param {restaurantsTableReservationsSettingsTableManagementAvailableOnlineHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsTableReservationsSettingsTableManagementAvailableOnlineHover = function (params) {
    return { evid: 1458, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} webReservationsUserActionSaveParams
* @property {string} actionName - unique action name
* @property {GUID} locationGuid - restaurant location ID
* @property {string} origin - tbd
* @property {string} screenName - unique screen name
* @property {string} settingsDetails - JSON with saved settings details
* @property {string} userEntry - null
**/
/**
 * Name: Web.Reservations.User.ActionSave. Evid: 1403.
 * Event description: Actions in User Web flow..

 * actionName - Type: string. Desc: unique action name
 *
 * locationGuid - Type: guid. Desc: restaurant location ID
 *
 * origin - Type: string. Desc: tbd
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * settingsDetails - Type: string. Desc: JSON with saved settings details
 *
 * userEntry - Type: string.
 * @param {webReservationsUserActionSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUserActionSave = function (params) {
    return { evid: 1403, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsReservationsPageUpperComponentSearchFinishTypingParams
* @property {GUID} locationGuid - -
* @property {string} biToken - -
* @property {number} numResults - -
* @property {string} text - the text the user search
* @property {string} uuid - -
**/
/**
 * Name: Table reservations > reservations page > upper component > search > finish typing. Evid: 1439.
 * Event description: when the user finish typing on order to search.

 * locationGuid - Type: guid. Desc: -
 *
 * biToken - Type: string. Desc: -
 *
 * numResults - Type: numeric. Desc: -
 *
 * text - Type: string. Desc: the text the user search
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationsReservationsPageUpperComponentSearchFinishTypingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsReservationsPageUpperComponentSearchFinishTyping = function (params) {
    return { evid: 1439, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilitySettingsPartySizeComponentClickOnEditTurnoverRulesParams
* @property {string} availabilityComponent - party_size
* @property {string} buttonName - edit
* @property {string} defaultReservationDuration - -
* @property {GUID} locationGuid - -
* @property {number} numRules - number of existing  rules when the user tend to edit
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > availability settings > party size component > click on edit turnover rules. Evid: 1429.
 * Event description: edit duration rules.

 * availabilityComponent - Type: string. Desc: party_size
 *
 * buttonName - Type: string. Desc: edit
 *
 * defaultReservationDuration - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numRules - Type: numeric. Desc: number of existing  rules when the user tend to edit
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsAvailabilitySettingsPartySizeComponentClickOnEditTurnoverRulesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilitySettingsPartySizeComponentClickOnEditTurnoverRules = function (params) {
    return { evid: 1429, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsReservationsFormToggleClicksParams
* @property {string} action_type - on/off
* @property {GUID} locationGuid - -
* @property {string} restId - -
* @property {string} toggleName - email_as_mandatory / last_name_mandatory/custom_fields / custom_message / reservation_policies / phone_validation
**/
/**
 * Name: Table reservation > settings > reservations form > toggle clicks. Evid: 1435.
 * Event description: when the user clicks on one of the toggles on the reservation form page.

 * action_type - Type: string. Desc: on/off
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * toggleName - Type: string. Desc: email_as_mandatory / last_name_mandatory/custom_fields / custom_message / reservation_policies / phone_validation
 * @param {tableReservationSettingsReservationsFormToggleClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsReservationsFormToggleClicks = function (params) {
    return { evid: 1435, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} webReservationsUserButtonClickParams
* @property {string} buttonName - unique button name
* @property {GUID} locationGuid - location id
* @property {string} origin - widget / page
* @property {string} screenName - unique screen name
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.User.ButtonClick. Evid: 1401.
 * Event description: Button Clicks in User Web flows (BM/Preview/Site)..

 * buttonName - Type: string. Desc: unique button name
 *
 * locationGuid - Type: guid. Desc: location id
 *
 * origin - Type: string. Desc: widget / page
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUserButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUserButtonClick = function (params) {
    return { evid: 1401, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/*event 1400 on project 'com.wixpress.table-reservations-web-user' has no function name set, please set one in BI Catalog.*/
/**
* @typedef {Object} tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalDeleteEventClickParams
* @property {string} endDate - -
* @property {DateTime} endTime - -
* @property {number} eventId - -
* @property {GUID} locationId - -
* @property {number} numDays - -
* @property {string} restId - -
* @property {string} startDate - -
* @property {DateTime} startTime - -
* @property {string} type - available/unavailable
**/
/**
 * Name: Table reservation > settings > Availability > Online reservation section > schedule modal > delete event click. Evid: 1447.
 * Event description: delete event click.

 * endDate - Type: string. Desc: -
 *
 * endTime - Type: datetime. Desc: -
 *
 * eventId - Type: numeric. Desc: -
 *
 * locationId - Type: guid. Desc: -
 *
 * numDays - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * startDate - Type: string. Desc: -
 *
 * startTime - Type: datetime. Desc: -
 *
 * type - Type: string. Desc: available/unavailable
 * @param {tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalDeleteEventClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalDeleteEventClick = function (params) {
    return { evid: 1447, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementSettingsIsLoadedParams
* @property {GUID} locationGuid - -
* @property {number} numSeats - -
* @property {number} numTables - -
* @property {number} numTablesCombinations - num of table combinations
* @property {string} pageName - table_management
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} tablesList - json of of [table name: X, min:1, max:5] , [table name:y , min:6 , max: 7 ]...
**/
/**
 * Name: Table reservation > settings > table management settings is loaded. Evid: 1422.
 * Event description: when the page of table management is loaded.

 * locationGuid - Type: guid. Desc: -
 *
 * numSeats - Type: numeric. Desc: -
 *
 * numTables - Type: numeric. Desc: -
 *
 * numTablesCombinations - Type: numeric. Desc: num of table combinations
 *
 * pageName - Type: string. Desc: table_management
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * tablesList - Type: string. Desc: json of of [table name: X, min:1, max:5] , [table name:y , min:6 , max: 7 ]...
 * @param {tableReservationSettingsTableManagementSettingsIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementSettingsIsLoaded = function (params) {
    return { evid: 1422, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationCreateReservationSucceedParams
* @property {string} additionalDetails - json of the additional fields
* @property {string} areaType - -
* @property {string} addingTableID - -
* @property {string} assignTableIds - -
* @property {string} assignTableName - -
* @property {string} assignTableNames - array of table names in combination
* @property {string} assignTablesNames - -
* @property {string} contactId - id if its from uou side
* @property {string} correlationId - -
* @property {DateTime} creationDate - -
* @property {DateTime} datetime - -
* @property {DateTime} duration - the duration of the reservation - in A milli second
* @property {string} email - -
* @property {boolean} isTableOverbooked - true/false
* @property {string} locationGuid - -
* @property {string} mailCheckbox - when the uou is check/uncheck this checkbox
* @property {string} biToken - -
* @property {string} name - -
* @property {number} numDetailsEmpty - -
* @property {number} numDetailsFull - -
* @property {number} numDetailsMandatory - -
* @property {string} origin - live_site_mode / preview_mode
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {string} reservation__id - -
* @property {GUID} reservationLocationId - -
* @property {string} reservationType - who did the reservation uou or owenr?
* @property {string} rest_id - --
* @property {string} saveType - created/edit
* @property {string} teamMessage - json of the text
* @property {boolean} teamMessageEmpty - True if its empty and false if not
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > create reservation succeed. Evid: 1450.
 * Event description: create reservation succeeds.

 * additionalDetails - Type: string. Desc: json of the additional fields
 *
 * areaType - Type: string. Desc: -
 *
 * addingTableID - Type: string. Desc: -
 *
 * assignTableIds - Type: string. Desc: -
 *
 * assignTableName - Type: string. Desc: -
 *
 * assignTableNames - Type: string. Desc: array of table names in combination
 *
 * assignTablesNames - Type: string. Desc: -
 *
 * contactId - Type: string. Desc: id if its from uou side
 *
 * correlationId - Type: string. Desc: -
 *
 * creationDate - Type: datetime. Desc: -
 *
 * datetime - Type: datetime. Desc: -
 *
 * duration - Type: datetime. Desc: the duration of the reservation - in A milli second
 *
 * email - Type: string. Desc: -
 *
 * isTableOverbooked - Type: bool. Desc: true/false
 *
 * locationGuid - Type: string. Desc: -
 *
 * mailCheckbox - Type: string. Desc: when the uou is check/uncheck this checkbox
 *
 * biToken - Type: string. Desc: -
 *
 * name - Type: string. Desc: -
 *
 * numDetailsEmpty - Type: numeric. Desc: -
 *
 * numDetailsFull - Type: numeric. Desc: -
 *
 * numDetailsMandatory - Type: numeric. Desc: -
 *
 * origin - Type: string. Desc: live_site_mode / preview_mode
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservation__id - Type: string. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationType - Type: string. Desc: who did the reservation uou or owenr?
 *
 * rest_id - Type: string. Desc: --
 *
 * saveType - Type: string. Desc: created/edit
 *
 * teamMessage - Type: string. Desc: json of the text
 *
 * teamMessageEmpty - Type: bool. Desc: True if its empty and false if not
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationCreateReservationSucceedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationCreateReservationSucceed = function (params) {
    return { evid: 1450, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsDiscardSpecificSectionChangesParams
* @property {string} currentToggle - toggle_off/ toggle_on
* @property {string} locationGuid - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} settingsSection - table_manage/ availability/ reservation_form/ notifications
**/
/**
 * Name: Table reservation > Settings > Click on discard specific section changes. Evid: 1420.
 * Event description: when the user clicks on discard on the top of the page of each of the sections (table management/availability/notifications/reservation form).

 * currentToggle - Type: string. Desc: toggle_off/ toggle_on
 *
 * locationGuid - Type: string. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * settingsSection - Type: string. Desc: table_manage/ availability/ reservation_form/ notifications
 * @param {tableReservationSettingsDiscardSpecificSectionChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsDiscardSpecificSectionChanges = function (params) {
    return { evid: 1420, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationCreateReservationModalClickOnCancelParams
* @property {string} buttonName - x or cancel
* @property {string} locationGuid - -
* @property {string} biToken - -
* @property {number} numAdditionalFileds - -
* @property {number} numFullFields - -
* @property {string} rest_id - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > Create reservation modal > Click on cancel. Evid: 1411.
 * Event description: when the user clicks to cancel the creation of a reservation.

 * buttonName - Type: string. Desc: x or cancel
 *
 * locationGuid - Type: string. Desc: -
 *
 * biToken - Type: string. Desc: -
 *
 * numAdditionalFileds - Type: numeric. Desc: -
 *
 * numFullFields - Type: numeric. Desc: -
 *
 * rest_id - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationCreateReservationModalClickOnCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationCreateReservationModalClickOnCancel = function (params) {
    return { evid: 1411, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} webReservationsUserErrorTypeParams
* @property {string} errorType - unique error name
* @property {GUID} locationGuid - location id
* @property {string} origin - widget / page
* @property {string} screenName - unique screen name
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.User.ErrorType. Evid: 1404.
 * Event description: Error in User Web flows (BM)..

 * errorType - Type: string. Desc: unique error name
 *
 * locationGuid - Type: guid. Desc: location id
 *
 * origin - Type: string. Desc: widget / page
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUserErrorTypeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUserErrorType = function (params) {
    return { evid: 1404, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsSettingsReservationFormPageIsLoadedParams
* @property {string} customFieldsText - json with the text and +mandatory if it is
* @property {string} customFieldsToggle - on/off
* @property {string} customMessageText - json
* @property {string} customMessageToggle - on/off
* @property {string} emailMandatoryToggle - on/off
* @property {string} emailMarketingCheckByDeafult - check/uncheck
* @property {string} emailMarketingCheckboxToggle - on/off
* @property {string} lastNameMandatoryToggle - on/off
* @property {GUID} locationGuid - -
* @property {number} numCustomFields - -
* @property {number} numMandatoryFileds - -
* @property {string} phoneValidationToggle - on/off
* @property {string} policiesTermsCond - check/uncheck
* @property {string} privacyPolicy - check/uncheck
* @property {string} privacyPolicyText - json of the text
* @property {string} privacyPolicyType - text/url/null
* @property {string} reservationPoliciesToggle - on/off
* @property {string} restId - -
* @property {string} termsAndConditionsText - json of the text
* @property {string} termsCondType - text/url/null
**/
/**
 * Name: Table reservations > settings > reservation form page is loaded. Evid: 1433.
 * Event description: reservation form page is loaded.

 * customFieldsText - Type: string. Desc: json with the text and +mandatory if it is
 *
 * customFieldsToggle - Type: string. Desc: on/off
 *
 * customMessageText - Type: string. Desc: json
 *
 * customMessageToggle - Type: string. Desc: on/off
 *
 * emailMandatoryToggle - Type: string. Desc: on/off
 *
 * emailMarketingCheckByDeafult - Type: string. Desc: check/uncheck
 *
 * emailMarketingCheckboxToggle - Type: string. Desc: on/off
 *
 * lastNameMandatoryToggle - Type: string. Desc: on/off
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numCustomFields - Type: numeric. Desc: -
 *
 * numMandatoryFileds - Type: numeric. Desc: -
 *
 * phoneValidationToggle - Type: string. Desc: on/off
 *
 * policiesTermsCond - Type: string. Desc: check/uncheck
 *
 * privacyPolicy - Type: string. Desc: check/uncheck
 *
 * privacyPolicyText - Type: string. Desc: json of the text
 *
 * privacyPolicyType - Type: string. Desc: text/url/null
 *
 * reservationPoliciesToggle - Type: string. Desc: on/off
 *
 * restId - Type: string. Desc: -
 *
 * termsAndConditionsText - Type: string. Desc: json of the text
 *
 * termsCondType - Type: string. Desc: text/url/null
 * @param {tableReservationsSettingsReservationFormPageIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsSettingsReservationFormPageIsLoaded = function (params) {
    return { evid: 1433, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsMyReservationsPageClickOnAnotherLocationParams
* @property {string} clickedLocation - -
* @property {string} currentLocation - can also be default location
* @property {boolean} deletedLocation - True/false
* @property {number} numLocations - -
* @property {string} pageName - settings/ table_reservations
**/
/**
 * Name: Table reservations > my reservations page > click on another location. Evid: 1417.
 * Event description: when the user clicks on one of the locations in the  dropdown.

 * clickedLocation - Type: string. Desc: -
 *
 * currentLocation - Type: string. Desc: can also be default location
 *
 * deletedLocation - Type: bool. Desc: True/false
 *
 * numLocations - Type: numeric. Desc: -
 *
 * pageName - Type: string. Desc: settings/ table_reservations
 * @param {tableReservationsMyReservationsPageClickOnAnotherLocationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsMyReservationsPageClickOnAnotherLocation = function (params) {
    return { evid: 1417, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsPageSpecificReservationClicksParams
* @property {string} email - -
* @property {GUID} locationGuid - -
* @property {GUID} bi_token - -
* @property {string} name - -
* @property {number} numReservations - number of reservations in the page
* @property {string} origin - owner/uou (who create the reservation?)
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {string} reservation__id - -
* @property {DateTime} reservationDateCreated - -
* @property {DateTime} reservationTime - -
* @property {string} rest_id - -
* @property {string} tableName - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservations page >  specific reservation > clicks. Evid: 1407.
 * Event description: table reservations page - when the user clicks on one of these - create&edit reservation / cancel reservation.

 * email - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * bi_token - Type: guid. Desc: -
 *
 * name - Type: string. Desc: -
 *
 * numReservations - Type: numeric. Desc: number of reservations in the page
 *
 * origin - Type: string. Desc: owner/uou (who create the reservation?)
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservation__id - Type: string. Desc: -
 *
 * reservationDateCreated - Type: datetime. Desc: -
 *
 * reservationTime - Type: datetime. Desc: -
 *
 * rest_id - Type: string. Desc: -
 *
 * tableName - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationsPageSpecificReservationClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsPageSpecificReservationClicks = function (params) {
    return { evid: 1407, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementDeleteTableModalParams
* @property {string} buttonName - “x”/”cancel”/ “delete” / “external_click” (outside the modal)
* @property {GUID} instanceId - -
* @property {boolean} isDuplicate - is the table was duplicated in tis session?
* @property {GUID} locationGuid - -
* @property {number} maxGuests - -
* @property {number} minGuests - -
* @property {string} restId - -
* @property {string} tableName - -
**/
/**
 * Name: Table reservation > settings > table management > delete table modal. Evid: 1441.
 * Event description: clicks inside the deleting table modal -.

 * buttonName - Type: string. Desc: “x”/”cancel”/ “delete” / “external_click” (outside the modal)
 *
 * instanceId - Type: guid. Desc: -
 *
 * isDuplicate - Type: bool. Desc: is the table was duplicated in tis session?
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxGuests - Type: numeric. Desc: -
 *
 * minGuests - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * tableName - Type: string. Desc: -
 * @param {tableReservationSettingsTableManagementDeleteTableModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementDeleteTableModal = function (params) {
    return { evid: 1441, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsPageHoverParams
* @property {DateTime} datetime - the date and time of the reservation
* @property {string} hoverType - removed_table/ team_message /time_zone
* @property {GUID} locationGuid - -
* @property {GUID} biToken - -
* @property {string} orderId - -
* @property {string} origin - owner/uou (who create the reservation)
* @property {number} partySize - -
* @property {string} rest_id - -
* @property {string} tableID - -
* @property {string} timeZone - the timezone of the restaurant
* @property {string} uuid - -
**/
/**
 * Name: Table reservations page > hover. Evid: 1405.
 * Event description: when the user hover (put his mouse on button and see a tooltip).

 * datetime - Type: datetime. Desc: the date and time of the reservation
 *
 * hoverType - Type: string. Desc: removed_table/ team_message /time_zone
 *
 * locationGuid - Type: guid. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * orderId - Type: string. Desc: -
 *
 * origin - Type: string. Desc: owner/uou (who create the reservation)
 *
 * partySize - Type: numeric. Desc: -
 *
 * rest_id - Type: string. Desc: -
 *
 * tableID - Type: string. Desc: -
 *
 * timeZone - Type: string. Desc: the timezone of the restaurant
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationsPageHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsPageHover = function (params) {
    return { evid: 1405, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationMainReservationSettingsPageClicksParams
* @property {string} buttonName - manage_reservation/ table_manage/availability/reservation_form/ notifications/
* @property {string} currentToggle - on or off
* @property {string} locationGuid - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > Main reservation settings page > clicks. Evid: 1418.
 * Event description: when the user clicks on buttons in the main settings page of the table reservation.

 * buttonName - Type: string. Desc: manage_reservation/ table_manage/availability/reservation_form/ notifications/
 *
 * currentToggle - Type: string. Desc: on or off
 *
 * locationGuid - Type: string. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationMainReservationSettingsPageClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationMainReservationSettingsPageClicks = function (params) {
    return { evid: 1418, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalCreatingEventClicksParams
* @property {string} element - -
* @property {number} eventId - -
* @property {GUID} locationId - -
* @property {number} numDays - -
* @property {string} restId - -
* @property {string} type - -
**/
/**
 * Name: Table reservation > settings > Availability > Online reservation section > schedule modal > creating event clicks. Evid: 1446.
 * Event description: clicks inside schedule modal on delete custom rule.

 * element - Type: string. Desc: -
 *
 * eventId - Type: numeric. Desc: -
 *
 * locationId - Type: guid. Desc: -
 *
 * numDays - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * type - Type: string. Desc: -
 * @param {tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalCreatingEventClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityOnlineReservationSectionScheduleModalCreatingEventClicks = function (params) {
    return { evid: 1446, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilityPageClickSaveParams
* @property {string} advancedNoticeType - minuted / hours/ days
* @property {string} availabilityHoursList - son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
* @property {string} advancedNoticeNum - -
* @property {string} defaultTime - of reservation duration
* @property {string} displayPhoneCheckbox - check/ uncheck
* @property {string} durationRulesList - json list of the rules
* @property {number} guestsMinutes - right now should be 15
* @property {number} guestsPacing - -
* @property {GUID} locationGuid - -
* @property {number} maxPartySize - -
* @property {number} minPartySize - -
* @property {number} numExistingEvents - number of events that were existing before this saving
* @property {number} numNewEvents - number of new events at the availability modal
* @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
* @property {string} pageName - availability_settings
* @property {number} partiesMinutes - right now should be 15
* @property {number} partiesPacing - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} scheduleType - opening_hours / custom
**/
/**
 * Name: Table reservation > settings > availability page > click save. Evid: 1427.
 * Event description: when the user save the availability settings page.

 * advancedNoticeType - Type: string. Desc: minuted / hours/ days
 *
 * availabilityHoursList - Type: string. Desc: son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 *
 * advancedNoticeNum - Type: string. Desc: -
 *
 * defaultTime - Type: string. Desc: of reservation duration
 *
 * displayPhoneCheckbox - Type: string. Desc: check/ uncheck
 *
 * durationRulesList - Type: string. Desc: json list of the rules
 *
 * guestsMinutes - Type: numeric. Desc: right now should be 15
 *
 * guestsPacing - Type: numeric. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxPartySize - Type: numeric. Desc: -
 *
 * minPartySize - Type: numeric. Desc: -
 *
 * numExistingEvents - Type: numeric. Desc: number of events that were existing before this saving
 *
 * numNewEvents - Type: numeric. Desc: number of new events at the availability modal
 *
 * numTurnoverRules - Type: numeric. Desc: how many rules of turnover are exist at the loading
 *
 * pageName - Type: string. Desc: availability_settings
 *
 * partiesMinutes - Type: numeric. Desc: right now should be 15
 *
 * partiesPacing - Type: numeric. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * scheduleType - Type: string. Desc: opening_hours / custom
 * @param {tableReservationSettingsAvailabilityPageClickSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityPageClickSave = function (params) {
    return { evid: 1427, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTryingToLeaveAPageModalEngagementParams
* @property {string} actionName - modal_jump / click
* @property {string} buttonName - cancel/leave/x_button / external_click (when the modal is jumping this fields will be null)
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} moveToPage - trying to move to which page?
* @property {string} pageName - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > trying to leave a page modal engagement. Evid: 1440.
 * Event description: when user trying toleave the page this modal is jumping. this event is fired when the modal is jumping or when the user clicks on the button of the modal.

 * actionName - Type: string. Desc: modal_jump / click
 *
 * buttonName - Type: string. Desc: cancel/leave/x_button / external_click (when the modal is jumping this fields will be null)
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * moveToPage - Type: string. Desc: trying to move to which page?
 *
 * pageName - Type: string. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsTryingToLeaveAPageModalEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTryingToLeaveAPageModalEngagement = function (params) {
    return { evid: 1440, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams
* @property {boolean} isAvailableOnline - true/false
* @property {GUID} locationGuid - -
* @property {number} maxSeats - -
* @property {number} minSeats - -
* @property {number} numTablesInCombination - number of tables inside the combination
* @property {string} objectId - tabel id or combinationdid
* @property {string} objectName - table name / co
* @property {GUID} reservationLocationId - -
* @property {GUID} reservationsLocationId - -
* @property {string} type - table/table combinations
**/
/**
 * Name: Restaurants > Table reservations > Settings > Table Management > Table object created. Evid: 1460.


 * isAvailableOnline - Type: bool. Desc: true/false
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxSeats - Type: numeric. Desc: -
 *
 * minSeats - Type: numeric. Desc: -
 *
 * numTablesInCombination - Type: numeric. Desc: number of tables inside the combination
 *
 * objectId - Type: string. Desc: tabel id or combinationdid
 *
 * objectName - Type: string. Desc: table name / co
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationsLocationId - Type: guid. Desc: -
 *
 * type - Type: string. Desc: table/table combinations
 * @param {restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsTableReservationsSettingsTableManagementTableObjectCreated = function (params) {
    return { evid: 1460, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfullyParams
* @property {string} columnsOrder - json of the order by the names
* @property {GUID} locationGuid - -
* @property {GUID} biToken - -
* @property {number} numColumns - -
* @property {number} numReservations - num reservations in the page
* @property {GUID} reservationLocationId - -
* @property {string} uuid - null
**/
/**
 * Name: Table reservations > changes in customize columns > changes saved successfully. Evid: 1415.
 * Event description: when the changes that the user made are saved successfully.

 * columnsOrder - Type: string. Desc: json of the order by the names
 *
 * locationGuid - Type: guid. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * numColumns - Type: numeric. Desc: -
 *
 * numReservations - Type: numeric. Desc: num reservations in the page
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * uuid - Type: string.
 * @param {tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfullyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfully = function (params) {
    return { evid: 1415, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationCancelationSucceedParams
* @property {string} additionalDetailsJson - -
* @property {string} areaCode - -
* @property {string} addingTableID - json of the additional fields
* @property {string} assignTableName - -
* @property {string} contactId - -
* @property {string} createdBy - who cancel the reservations?
* @property {DateTime} creationDate - -
* @property {DateTime} datetime - -
* @property {DateTime} duration - the duration of the reservation
* @property {string} email - -
* @property {boolean} isTableOverbooked - true/false
* @property {string} locationGuid - -
* @property {string} mailCheckbox - -
* @property {string} biToken - -
* @property {string} name - -
* @property {number} numDetailsEmpty - -
* @property {number} numDetailsFull - -
* @property {number} numDetailsMandatory - -
* @property {string} origin - live_site / preview mode
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {string} reservation__id - -
* @property {GUID} reservationLocationId - -
* @property {string} reservationType - -
* @property {string} rest_id - --
* @property {string} teamMessage - json of the text
* @property {boolean} teamMessageEmpty - True if its empty and false if not
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > cancelation succeed. Evid: 1454.
 * Event description: reservation cancelation succeed (uou and owner).

 * additionalDetailsJson - Type: string. Desc: -
 *
 * areaCode - Type: string. Desc: -
 *
 * addingTableID - Type: string. Desc: json of the additional fields
 *
 * assignTableName - Type: string. Desc: -
 *
 * contactId - Type: string. Desc: -
 *
 * createdBy - Type: string. Desc: who cancel the reservations?
 *
 * creationDate - Type: datetime. Desc: -
 *
 * datetime - Type: datetime. Desc: -
 *
 * duration - Type: datetime. Desc: the duration of the reservation
 *
 * email - Type: string. Desc: -
 *
 * isTableOverbooked - Type: bool. Desc: true/false
 *
 * locationGuid - Type: string. Desc: -
 *
 * mailCheckbox - Type: string. Desc: -
 *
 * biToken - Type: string. Desc: -
 *
 * name - Type: string. Desc: -
 *
 * numDetailsEmpty - Type: numeric. Desc: -
 *
 * numDetailsFull - Type: numeric. Desc: -
 *
 * numDetailsMandatory - Type: numeric. Desc: -
 *
 * origin - Type: string. Desc: live_site / preview mode
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservation__id - Type: string. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationType - Type: string. Desc: -
 *
 * rest_id - Type: string. Desc: --
 *
 * teamMessage - Type: string. Desc: json of the text
 *
 * teamMessageEmpty - Type: bool. Desc: True if its empty and false if not
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationCancelationSucceedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationCancelationSucceed = function (params) {
    return { evid: 1454, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementDeleteTableSuccessParams
* @property {GUID} instanceId - -
* @property {boolean} isDuplicate - is the table was duplicated in tis session?
* @property {GUID} locationGuid - -
* @property {number} maxGuests - -
* @property {number} minGuests - -
* @property {string} restId - -
* @property {boolean} isSuccess - true/false
* @property {string} tableName - -
**/
/**
 * Name: Table reservation > settings > table management > delete table success. Evid: 1442.
 * Event description: delete table success.

 * instanceId - Type: guid. Desc: -
 *
 * isDuplicate - Type: bool. Desc: is the table was duplicated in tis session?
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxGuests - Type: numeric. Desc: -
 *
 * minGuests - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * isSuccess - Type: bool. Desc: true/false
 *
 * tableName - Type: string. Desc: -
 * @param {tableReservationSettingsTableManagementDeleteTableSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementDeleteTableSuccess = function (params) {
    return { evid: 1442, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementClickOnSaveParams
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {number} numCombinations - -
* @property {number} numDuplicatedTablesInSession - -
* @property {number} numNewCombinations - only the new tables from this session
* @property {number} numNewTables - only the new tables from this session
* @property {number} numOnlineCombinations - -
* @property {number} numOnlineTables - -
* @property {number} numTables - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} tabName - tables / table_cobinations
* @property {string} tablesListActions - json of {action:.. , before:.., after:...,} action can be “change”/”add”/”delete” and before and after are the names of the table +min and max party size
* @property {number} totalNewSeats - only the new tables from this session
* @property {number} totalSeats - -
**/
/**
 * Name: Table reservation > settings > table management > click on save. Evid: 1443.
 * Event description: click on save changes in table management settings.

 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numCombinations - Type: numeric. Desc: -
 *
 * numDuplicatedTablesInSession - Type: numeric. Desc: -
 *
 * numNewCombinations - Type: numeric. Desc: only the new tables from this session
 *
 * numNewTables - Type: numeric. Desc: only the new tables from this session
 *
 * numOnlineCombinations - Type: numeric. Desc: -
 *
 * numOnlineTables - Type: numeric. Desc: -
 *
 * numTables - Type: numeric. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * tabName - Type: string. Desc: tables / table_cobinations
 *
 * tablesListActions - Type: string. Desc: json of {action:.. , before:.., after:...,} action can be “change”/”add”/”delete” and before and after are the names of the table +min and max party size
 *
 * totalNewSeats - Type: numeric. Desc: only the new tables from this session
 *
 * totalSeats - Type: numeric. Desc: -
 * @param {tableReservationSettingsTableManagementClickOnSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementClickOnSave = function (params) {
    return { evid: 1443, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsPageToggleAction1451Params
* @property {string} action_type - toggle_off/ toggle_on
* @property {string} locationGuid - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings page > toggle action. Evid: 1451.
 * Event description: when the user clicks on the toggle.

 * action_type - Type: string. Desc: toggle_off/ toggle_on
 *
 * locationGuid - Type: string. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsPageToggleAction1451Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsPageToggleAction1451 = function (params) {
    return { evid: 1451, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationReservationsPageCancelReservationCancelationModalClicksParams
* @property {string} buttonName - x / discard/cancel
* @property {string} email - -
* @property {string} locationGuid - -
* @property {GUID} biToken - -
* @property {string} name - -
* @property {string} origin - owner / uou (who did the reservation?)
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {string} reservation__id - -
* @property {DateTime} reservationDateCreated - -
* @property {DateTime} reservationTime - -
* @property {string} tableName - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > reservations page > cancel reservation > cancelation modal > clicks. Evid: 1408.
 * Event description: when the user clicks on the buttons inside the cancelation reservation modal (x button/cancel/discard).

 * buttonName - Type: string. Desc: x / discard/cancel
 *
 * email - Type: string. Desc: -
 *
 * locationGuid - Type: string. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * name - Type: string. Desc: -
 *
 * origin - Type: string. Desc: owner / uou (who did the reservation?)
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservation__id - Type: string. Desc: -
 *
 * reservationDateCreated - Type: datetime. Desc: -
 *
 * reservationTime - Type: datetime. Desc: -
 *
 * tableName - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationReservationsPageCancelReservationCancelationModalClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationReservationsPageCancelReservationCancelationModalClicks = function (params) {
    return { evid: 1408, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilitySettingsGeneralClicksParams
* @property {string} availabilityComponent - online_reservations / party_size / advances_notice / pacing
* @property {string} buttonName - edit /
* @property {string} checkBoxClick - check/uncheck/null
* @property {string} element - -
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > availability settings > general clicks. Evid: 1428.
 * Event description: general clicks in the availability settings.

 * availabilityComponent - Type: string. Desc: online_reservations / party_size / advances_notice / pacing
 *
 * buttonName - Type: string. Desc: edit /
 *
 * checkBoxClick - Type: string. Desc: check/uncheck/null
 *
 * element - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsAvailabilitySettingsGeneralClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilitySettingsGeneralClicks = function (params) {
    return { evid: 1428, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationCreateReservationModalIsLoadedParams
* @property {string} locationGuid - -
* @property {string} modalType - edit / create
* @property {string} biToken - -
* @property {number} numAdditionalFileds - -
* @property {number} numMandatoryFileds - -
* @property {string} rest_id - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > create /edit reservation modal is loaded. Evid: 1410.
 * Event description: when the modal of creating reservation is loaded to the user.

 * locationGuid - Type: string. Desc: -
 *
 * modalType - Type: string. Desc: edit / create
 *
 * biToken - Type: string. Desc: -
 *
 * numAdditionalFileds - Type: numeric. Desc: -
 *
 * numMandatoryFileds - Type: numeric. Desc: -
 *
 * rest_id - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationCreateReservationModalIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationCreateReservationModalIsLoaded = function (params) {
    return { evid: 1410, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsMyReservationsPageClickOnLocationDropdownParams
* @property {string} currentLocation - can also be default location
* @property {boolean} deletedLocation - True/false
* @property {number} numLocations - -
* @property {string} pageName - settings/ table_reservations
**/
/**
 * Name: Table reservations > my reservations page > click on location dropdown. Evid: 1416.
 * Event description: when the user clicks on the location dropdown.

 * currentLocation - Type: string. Desc: can also be default location
 *
 * deletedLocation - Type: bool. Desc: True/false
 *
 * numLocations - Type: numeric. Desc: -
 *
 * pageName - Type: string. Desc: settings/ table_reservations
 * @param {tableReservationsMyReservationsPageClickOnLocationDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsMyReservationsPageClickOnLocationDropdown = function (params) {
    return { evid: 1416, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsBoReservationsModalOpenedParams
* @property {GUID} locationGuid - -
* @property {GUID} locationId - -
* @property {GUID} reservationLocationId - -
* @property {GUID} reservationsLocationId - -
* @property {string} type - create / edit
**/
/**
 * Name: Table Reservations > bo > Reservations modal opened. Evid: 1456.
 * Event description: modal of creating reservations is opened (loaded).

 * locationGuid - Type: guid. Desc: -
 *
 * locationId - Type: guid. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationsLocationId - Type: guid. Desc: -
 *
 * type - Type: string. Desc: create / edit
 * @param {tableReservationsBoReservationsModalOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsBoReservationsModalOpened = function (params) {
    return { evid: 1456, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationsReservationsPageUpperComponentStartTypingInSearchParams
* @property {GUID} locationGuid - -
* @property {string} biToken - -
* @property {string} uuid - -
**/
/**
 * Name: Table reservations > reservations page > upper component > start typing in search. Evid: 1414.
 * Event description: when the user uses the search and start writing.

 * locationGuid - Type: guid. Desc: -
 *
 * biToken - Type: string. Desc: -
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationsReservationsPageUpperComponentStartTypingInSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationsReservationsPageUpperComponentStartTypingInSearch = function (params) {
    return { evid: 1414, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilityPageIsLoadedParams
* @property {string} advancedNoticeType - minuted / hours/ days
* @property {string} availabilityHoursList - son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
* @property {string} advancedNoticeNum - -
* @property {string} defaultTime - of reservation duration
* @property {string} displayPhoneCheckbox - check/ uncheck
* @property {string} durationRulesList - json list of the rules
* @property {number} guestsMinutes - right now should be 15
* @property {number} guestsPacing - -
* @property {GUID} locationGuid - -
* @property {number} maxPartySize - -
* @property {number} minPartySize - -
* @property {number} numEvents - number of events in the availability hours
* @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
* @property {string} pageName - availability_settings
* @property {number} partiesMinutes - right now should be 15
* @property {number} partiesPacing - -
* @property {string} restId - -
* @property {string} scheduleType - opening_hours / custom
**/
/**
 * Name: Table reservation > settings > availability page is loaded. Evid: 1425.
 * Event description: when the availability settings page is loaded to the user.

 * advancedNoticeType - Type: string. Desc: minuted / hours/ days
 *
 * availabilityHoursList - Type: string. Desc: son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 *
 * advancedNoticeNum - Type: string. Desc: -
 *
 * defaultTime - Type: string. Desc: of reservation duration
 *
 * displayPhoneCheckbox - Type: string. Desc: check/ uncheck
 *
 * durationRulesList - Type: string. Desc: json list of the rules
 *
 * guestsMinutes - Type: numeric. Desc: right now should be 15
 *
 * guestsPacing - Type: numeric. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxPartySize - Type: numeric. Desc: -
 *
 * minPartySize - Type: numeric. Desc: -
 *
 * numEvents - Type: numeric. Desc: number of events in the availability hours
 *
 * numTurnoverRules - Type: numeric. Desc: how many rules of turnover are exist at the loading
 *
 * pageName - Type: string. Desc: availability_settings
 *
 * partiesMinutes - Type: numeric. Desc: right now should be 15
 *
 * partiesPacing - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * scheduleType - Type: string. Desc: opening_hours / custom
 * @param {tableReservationSettingsAvailabilityPageIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilityPageIsLoaded = function (params) {
    return { evid: 1425, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementSettingsHoversParams
* @property {string} hoverType - max_smaller_than_min/at_least_one_guest/enter_table_name
* @property {boolean} isDuplicate - true if it is already a duplicated table and false otherwise
* @property {GUID} locationGuid - -
* @property {number} numSeats - at the time of the click
* @property {number} numTables - at the time of the click
* @property {string} pageName - table_management
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > table management settings > hovers. Evid: 1424.
 * Event description: when the user put his mouse on some alerts and see tooltips with explanations.

 * hoverType - Type: string. Desc: max_smaller_than_min/at_least_one_guest/enter_table_name
 *
 * isDuplicate - Type: bool. Desc: true if it is already a duplicated table and false otherwise
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numSeats - Type: numeric. Desc: at the time of the click
 *
 * numTables - Type: numeric. Desc: at the time of the click
 *
 * pageName - Type: string. Desc: table_management
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsTableManagementSettingsHoversParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementSettingsHovers = function (params) {
    return { evid: 1424, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementSettingsClicksParams
* @property {string} buttonName - duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button
* @property {boolean} isDuplicate - true if it is already a duplicated table (from the same session) and false otherwise
* @property {GUID} locationGuid - -
* @property {number} maxGuests - null
* @property {number} minGuests - number of min guests of the duplicated table
* @property {number} numObjects - at the time of the click
* @property {number} numOfOnlineObjects - -
* @property {number} numSeats - num of total seats
* @property {GUID} objectId - table_id or combination_id
* @property {string} objectName - table name or a combination name of the duplicate/deleted object
* @property {string} pageName - table_management
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} tabName - -
**/
/**
 * Name: Table reservation > settings > table management settings > clicks. Evid: 1423.
 * Event description: when the user clicks on buttons inside the table management page.

 * buttonName - Type: string. Desc: duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button
 *
 * isDuplicate - Type: bool. Desc: true if it is already a duplicated table (from the same session) and false otherwise
 *
 * locationGuid - Type: guid. Desc: -
 *
 * maxGuests - Type: numeric.
 *
 * minGuests - Type: numeric. Desc: number of min guests of the duplicated table
 *
 * numObjects - Type: numeric. Desc: at the time of the click
 *
 * numOfOnlineObjects - Type: numeric. Desc: -
 *
 * numSeats - Type: numeric. Desc: num of total seats
 *
 * objectId - Type: guid. Desc: table_id or combination_id
 *
 * objectName - Type: string. Desc: table name or a combination name of the duplicate/deleted object
 *
 * pageName - Type: string. Desc: table_management
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * tabName - Type: string. Desc: -
 * @param {tableReservationSettingsTableManagementSettingsClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementSettingsClicks = function (params) {
    return { evid: 1423, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsAvailabilitySettingsHoversParams
* @property {string} availabilityComponent - pacing /party_size / online_reservation / advanced_notice
* @property {string} buttonName - ! / min/max
* @property {string} hoverType - Default_explenation/same_number_guests/  min_bigger_than_max/ more_than_party/zero_guests/get_to_maximum
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > availability settings > hovers. Evid: 1432.
 * Event description: click on apply inside duration rules modal.

 * availabilityComponent - Type: string. Desc: pacing /party_size / online_reservation / advanced_notice
 *
 * buttonName - Type: string. Desc: ! / min/max
 *
 * hoverType - Type: string. Desc: Default_explenation/same_number_guests/  min_bigger_than_max/ more_than_party/zero_guests/get_to_maximum
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsAvailabilitySettingsHoversParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsAvailabilitySettingsHovers = function (params) {
    return { evid: 1432, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationMainReservationSettingsPageIsLoadedParams
* @property {string} currentToggle - on or off
* @property {string} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > Main reservation settings page is loaded. Evid: 1419.
 * Event description: when the page of table reservations settings is loaded.

 * currentToggle - Type: string. Desc: on or off
 *
 * locationGuid - Type: string. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationMainReservationSettingsPageIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationMainReservationSettingsPageIsLoaded = function (params) {
    return { evid: 1419, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams
* @property {GUID} locationGuid - -
* @property {GUID} reservationLocationId - -
* @property {GUID} reservationsLocationId - -
* @property {string} tabName - -
**/
/**
 * Name: Restaurants> Table Reservations > Settings > Table management > click on tab without saving modal. Evid: 1459.
 * Event description: when the modal is loaded when user tries to move to another tab after he made changes and didn't save.

 * locationGuid - Type: guid. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * reservationsLocationId - Type: guid. Desc: -
 *
 * tabName - Type: string. Desc: -
 * @param {restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModal = function (params) {
    return { evid: 1459, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationSettingsTableManagementSaveChangesSuccessParams
* @property {GUID} locationGuid - -
* @property {number} numCombinations - -
* @property {number} numDuplicatedTablesInSession - -
* @property {number} numNewCombinations - from the session
* @property {number} numNewTables - from the session
* @property {number} numOnlineCombinations - -
* @property {number} numOnlineTables - -
* @property {number} numTables - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {boolean} success - true/false
* @property {string} tabName - -
* @property {string} tablesListActions - json of {action:.. , before:.., after:...,is_dummy:...} action can be “change”/”add”/”delete”/"no change" and before and after are the names of the table +min and max party size. is_dummy means if its one of the dummy tables tables that we give the user -false will be if the users is already edit it or if its a new table
* @property {number} totalNewSeats - from the session
* @property {number} totalSeats - -
**/
/**
 * Name: Table reservation > settings > table management >  save changes success. Evid: 1449.
 * Event description: save changes success.

 * locationGuid - Type: guid. Desc: -
 *
 * numCombinations - Type: numeric. Desc: -
 *
 * numDuplicatedTablesInSession - Type: numeric. Desc: -
 *
 * numNewCombinations - Type: numeric. Desc: from the session
 *
 * numNewTables - Type: numeric. Desc: from the session
 *
 * numOnlineCombinations - Type: numeric. Desc: -
 *
 * numOnlineTables - Type: numeric. Desc: -
 *
 * numTables - Type: numeric. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * success - Type: bool. Desc: true/false
 *
 * tabName - Type: string. Desc: -
 *
 * tablesListActions - Type: string. Desc: json of {action:.. , before:.., after:...,is_dummy:...} action can be “change”/”add”/”delete”/"no change" and before and after are the names of the table +min and max party size. is_dummy means if its one of the dummy tables tables that we give the user -false will be if the users is already edit it or if its a new table
 *
 * totalNewSeats - Type: numeric. Desc: from the session
 *
 * totalSeats - Type: numeric. Desc: -
 * @param {tableReservationSettingsTableManagementSaveChangesSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsTableManagementSaveChangesSuccess = function (params) {
    return { evid: 1449, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
/**
* @typedef {Object} tableReservationCreateNewReservationClickOnSaveReservationParams
* @property {string} additionalDetailsJson - json of the additional fields
* @property {string} addingTableID - -
* @property {string} assignTableName - -
* @property {DateTime} creationDate - -
* @property {DateTime} datetime - -
* @property {DateTime} duration - the duration of the reservation
* @property {string} email - -
* @property {boolean} isTableOverbooked - true/false
* @property {string} locationGuid - -
* @property {string} biToken - -
* @property {string} name - -
* @property {number} numDetailsEmpty - -
* @property {number} numDetailsFull - -
* @property {number} numDetailsMandatory - -
* @property {string} origin - owner/uou (who create the reservation?)
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {string} reservation__id - -
* @property {string} rest_id - --
* @property {string} teamMessage - json of the text
* @property {boolean} teamMessageEmpty - True if its empty and false if not
* @property {string} uuid - -
**/
/**
 * Name: Table reservation > create new reservation > click on save reservation. Evid: 1409.
 * Event description: create reservation succeeds.

 * additionalDetailsJson - Type: string. Desc: json of the additional fields
 *
 * addingTableID - Type: string. Desc: -
 *
 * assignTableName - Type: string. Desc: -
 *
 * creationDate - Type: datetime. Desc: -
 *
 * datetime - Type: datetime. Desc: -
 *
 * duration - Type: datetime. Desc: the duration of the reservation
 *
 * email - Type: string. Desc: -
 *
 * isTableOverbooked - Type: bool. Desc: true/false
 *
 * locationGuid - Type: string. Desc: -
 *
 * biToken - Type: string. Desc: -
 *
 * name - Type: string. Desc: -
 *
 * numDetailsEmpty - Type: numeric. Desc: -
 *
 * numDetailsFull - Type: numeric. Desc: -
 *
 * numDetailsMandatory - Type: numeric. Desc: -
 *
 * origin - Type: string. Desc: owner/uou (who create the reservation?)
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservation__id - Type: string. Desc: -
 *
 * rest_id - Type: string. Desc: --
 *
 * teamMessage - Type: string. Desc: json of the text
 *
 * teamMessageEmpty - Type: bool. Desc: True if its empty and false if not
 *
 * uuid - Type: string. Desc: -
 * @param {tableReservationCreateNewReservationClickOnSaveReservationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationCreateNewReservationClickOnSaveReservation = function (params) {
    return { evid: 1409, src: 61, endpoint: 'table-reservations-web-user', params: params };
};
//# sourceMappingURL=index.js.map